import React from "react";
import ReactDOM from "react-dom";
import MealsElements from "./components/mealsElements";
import Dietitian from "./components/dietitian";
import AddIns from "./components/addIns";
import AdditionalMeals from "./components/additionalMeals";
import { calculateMealsQuantity } from "./utils/functions";

function ProgressBarUncontrolled(props) {
  const priceRoot = document.getElementById("product-nav-price");
  const { selectedMeals, selectedAddIns, programType, dietType, dietitian, step, limitations, bundles } = props;

  const selectedBreakfastsQuantity = calculateMealsQuantity(selectedMeals.breakfasts);
  const selectedEntreesQuantity = calculateMealsQuantity(selectedMeals.entrees);

  let Wrap = () => {
    return (
      <>
        {step === 1 && (
          <>
            <Dietitian dietitian={dietitian} dietType={dietType} />
            <MealsElements
              dietType={dietType}
              selectedBreakfastsQuantity={selectedBreakfastsQuantity}
              selectedEntreesQuantity={selectedEntreesQuantity}
              programType={programType}
              limitations={limitations}
              selectedMeals={selectedMeals}
              bundles={bundles}
            />
            <AdditionalMeals
              dietType={dietType}
              programType={programType}
              selectedBreakfastsQuantity={selectedBreakfastsQuantity}
              selectedEntreesQuantity={selectedEntreesQuantity}
              limitations={limitations}
              selectedMeals={selectedMeals}
              bundles={bundles}
            />
          </>
        )}
        {step === 2 && <AddIns selectedAddIns={selectedAddIns} />}
      </>
    );
  };

  if (!priceRoot) return null;
  if (priceRoot) return ReactDOM.createPortal(<Wrap />, priceRoot);
}

export default ProgressBarUncontrolled;
